import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProfilesOfCurrentUser, updateProfile } from '../../redux/profilesSlice';
import ProfileCard from './ProfileCard';
import ProfileDetails from './ProfileDetails';
import EditProfileForm from './EditProfileForm';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CustomLoader from '../Common/CustomLoader';
import NoResults from '../Common/NoResults ';

const ProfilCandidature = () => {
  const dispatch = useDispatch();
  const { currentUserProfiles, loading, error } = useSelector(state => state.profiles);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchProfilesOfCurrentUser());
  }, [dispatch]);

  const handleUpdateProfile = (profile) => {
    setSelectedProfile(profile);
    setEditDialogOpen(true);
  };

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
    setSelectedProfile(null);
    dispatch(fetchProfilesOfCurrentUser());
  };

  const handleCloseDetails = () => setSelectedProfile(null);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CustomLoader />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error">
        Une erreur est survenue: {error}
      </Typography>
    );
  }

  if (!currentUserProfiles || currentUserProfiles.length === 0) {
    return (
      <Box textAlign="center" mt={4}>
        <NoResults />
      </Box>
    );
  }

  const profile = currentUserProfiles[0];

  return (
    <Box 
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      mt={4}
    >
      {selectedProfile ? (
        <Box width="80%">
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <IconButton onClick={handleCloseDetails}>
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h6" fontWeight={700}>
              Détails du profil
            </Typography>
          </Box>
          <ProfileDetails profile={selectedProfile} onUpdated={handleEditDialogClose} />
          {editDialogOpen && (
            <EditProfileForm
              profile={selectedProfile}
              onClose={handleEditDialogClose}
              onUpdate={handleEditDialogClose}
            />
          )}
        </Box>
      ) : (
        <ProfileCard 
          profile={profile} 
          onUpdate={handleUpdateProfile} 
          onClick={() => setSelectedProfile(profile)}
          className="profil-candidature-card" 
          sx={{ width: '600px', height: 'auto' }} // Increased width for the card
        />
      )}
    </Box>
  );
};

export default ProfilCandidature;
